import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/projects/mti/assets/img/footer/telegram.svg'
import _imports_1 from '@/projects/mti/assets/img/footer/dzen.svg'
import _imports_2 from '@/projects/mti/assets/img/footer/vk.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__container" }
const _hoisted_3 = { class: "footer__col left" }
const _hoisted_4 = { class: "footer__rights a-font__s" }
const _hoisted_5 = {
  class: "footer__privacy a-font__s",
  href: "/my/files/policy.pdf",
  target: "_blank"
}

import AppPersonalAgreementDialog from '@/shared/components/AppPersonalAgreementDialog/AppPersonalAgreementDialog.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, " © 2000 – " + _toDisplayString(new Date().getFullYear()) + " МТИ. Все права защищены ", 1),
        _createVNode(AppPersonalAgreementDialog, null, {
          default: _withCtx(() => [
            _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('footer.policy')), 1)
          ]),
          _: 1
        })
      ]),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"footer__col right\"><ul class=\"footer__social-list\"><li class=\"footer__social-item\"><a class=\"footer__social-link\" href=\"https://t.me/mti_institute\" target=\"_blank\"><img src=\"" + _imports_0 + "\" alt=\"\"></a></li><li class=\"footer__social-item\"><a class=\"footer__social-link\" href=\"https://dzen.ru/mti_institute\" target=\"_blank\"><img src=\"" + _imports_1 + "\" alt=\"\"></a></li><li class=\"footer__social-item\"><a class=\"footer__social-link\" href=\"https://vk.com/mti_vuz\" target=\"_blank\"><img src=\"" + _imports_2 + "\" alt=\"\"></a></li></ul></div><div class=\"phone\"><div class=\"phone-title\"> Телефон </div><a href=\"tel:88001008595\" class=\"phone-link\"> 8 800 100-85-95 </a></div>", 2))
    ])
  ]))
}
}

})